export default __webpack_public_path__ + "static/media/sy-csgh.2652b1a5.png";